<main id="conteudo" class="ads-shell" tabindex="-1">
  @if (busy()) {
  <div class="loading-overlay" role="status" aria-live="polite">
    <div class="spinner"></div>
    <p>{{ syncing() ? 'Atualizando e salvando publicidade...' : 'Carregando campanhas, anúncios e métricas de publicidade...' }}</p>
  </div>
  }

  <header class="card ads-hero">
    <div>
      <span class="eyebrow">Mercado Ads Product Ads</span>
      <h1>Dashboard de Publicidade</h1>
      <p>{{ activePeriodLabel() }} · cliques, impressões, conversões, gasto e ROAS.</p>
    </div>
    <div class="hero-actions no-print">
      <a class="btn btn-secondary" routerLink="/dashboard">Conciliação</a>
      <a class="btn btn-secondary" routerLink="/relatorios">Relatórios</a>
      <a class="btn btn-secondary" routerLink="/anuncios">Anúncios</a>
      <a class="btn btn-secondary" routerLink="/reputacao">Reputação</a>
      <button class="btn btn-secondary" type="button" (click)="logout()">Sair</button>
    </div>
  </header>

  <form class="card filters-card no-print" (ngSubmit)="syncSelectedRange()" aria-describedby="ads-filter-note">
    <div class="field">
      <label for="ads-period-range">Período</label>
      <select id="ads-period-range" name="range" [value]="selectedRange()" (change)="setRange($any($event.target).value)">
        <option value="last90">Últimos 90 dias</option>
        @for (month of months(); track month.month) {
        <option [value]="month.month">
          {{ formatMonth(month.month) }} · {{ month.hasData ? 'salvo' : 'não salvo' }}
        </option>
        }
      </select>
    </div>
    <div class="field">
      <label for="ads-site-id">Site</label>
      <select id="ads-site-id" name="siteId" [value]="siteId()" (change)="siteId.set($any($event.target).value)">
        <option value="MLB">Brasil (MLB)</option>
      </select>
    </div>
    <button class="btn btn-primary" type="submit" [disabled]="busy()">
      {{ selectedRange() === 'last90' ? 'Atualizar últimos 90 dias' : 'Atualizar mês pela API' }}
    </button>
    <button class="btn btn-secondary" type="button" [disabled]="busy()" (click)="loadAdsFromDatabase()">Recarregar banco</button>
    <p id="ads-filter-note" class="filter-note">
      Mercado Ads permite consultar no máximo os últimos 90 dias. Trocar o período lê primeiro o que já está salvo no banco.
    </p>
  </form>

  @if (message()) { <section class="card info-card">{{ message() }}</section> }
  @if (error()) { <section class="card info-card error">{{ error() }}</section> }

  @if (data(); as ads) {
  <section class="card context-card">
    <div>
      <span class="eyebrow">Anunciante</span>
      <strong>{{ ads.advertiser.name || ads.advertiser.id || 'Advertiser não identificado' }}</strong>
    </div>
    <div>
      <span class="eyebrow">Janelas consultadas</span>
      <strong>{{ ads.windows.length }}</strong>
      <p>{{ ads.source === 'database' ? 'Dados lidos do banco' : 'Dados recém-consultados na API' }}.</p>
    </div>
    <div>
      <span class="eyebrow">Campanhas</span>
      <strong>{{ ads.totals.campaignsCount }}</strong>
    </div>
    <div>
      <span class="eyebrow">Anúncios</span>
      <strong>{{ ads.totals.adsCount }}</strong>
    </div>
  </section>

  @if (months().length > 0) {
  <section class="card month-status-card no-print">
    <h2>Meses disponíveis nos últimos 90 dias</h2>
    <div class="month-status-grid">
      @for (month of months(); track month.month) {
      <button type="button" class="month-chip" [class.active]="selectedRange() === month.month" [attr.aria-pressed]="selectedRange() === month.month" (click)="setRange(month.month)">
        <strong>{{ formatMonth(month.month) }}</strong>
        <span>{{ month.hasData ? 'Salvo no banco' : 'Precisa atualizar' }}</span>
        @if (month.hasData) {
        <small>{{ month.cost | currency : 'BRL' : 'symbol' : '1.2-2' }} em Ads</small>
        }
      </button>
      }
    </div>
  </section>
  }

  <section class="kpi-grid">
    <article class="card kpi"><span>Gasto em Ads</span><strong>{{ ads.totals.cost | currency : 'BRL' : 'symbol' : '1.2-2' }}</strong></article>
    <article class="card kpi"><span>Impressões</span><strong>{{ ads.totals.impressions | number : '1.0-0' }}</strong></article>
    <article class="card kpi"><span>Cliques</span><strong>{{ ads.totals.clicks | number : '1.0-0' }}</strong></article>
    <article class="card kpi"><span>Conversões</span><strong>{{ ads.totals.conversions | number : '1.0-0' }}</strong></article>
    <article class="card kpi highlight"><span>Vendas atribuídas</span><strong>{{ ads.totals.sales | currency : 'BRL' : 'symbol' : '1.2-2' }}</strong></article>
    <article class="card kpi"><span>ROAS</span><strong>{{ ads.totals.roas | number : '1.2-2' }}x</strong></article>
    <article class="card kpi"><span>CPC médio</span><strong>{{ ads.totals.cpc | currency : 'BRL' : 'symbol' : '1.2-2' }}</strong></article>
    <article class="card kpi"><span>Conversão</span><strong>{{ ads.totals.conversionRate | number : '1.2-2' }}%</strong></article>
  </section>

  <section class="card recommendations-card">
    <div class="section-title-row">
      <div>
        <span class="eyebrow">Monitoramento contínuo</span>
        <h2>O que otimizar agora</h2>
        <p>Leitura prática para ajustar campanhas, visitas, conversões, títulos, descrições e preços.</p>
      </div>
    </div>
    @if (ads.recommendations.length > 0) {
    <div class="recommendation-grid">
      @for (item of ads.recommendations; track item.title) {
      <article class="recommendation" [class]="item.level">
        <strong>{{ item.title }}</strong>
        <p>{{ item.message }}</p>
      </article>
      }
    </div>
    } @else {
    <div class="empty-state"><strong>Sem recomendações automáticas para este período.</strong><p>Quando houver gasto, cliques e conversões, o painel destaca pontos de melhoria.</p></div>
    }
  </section>

  <section class="card table-wrap">
    <h2>Campanhas</h2>
    <p class="section-caption">Ordenado por maior gasto. Use para ver onde o orçamento está sendo consumido.</p>
    <table>
      <caption class="visually-hidden">Campanhas de publicidade ordenadas por gasto</caption>
      <thead><tr><th scope="col">Campanha</th><th scope="col">Status</th><th scope="col">Gasto</th><th scope="col">Impressões</th><th scope="col">Cliques</th><th scope="col">Conversões</th><th scope="col">Vendas</th><th scope="col">ROAS</th><th scope="col">CTR</th></tr></thead>
      <tbody>
        @for (campaign of topCampaigns(); track campaign.id) {
        <tr>
          <td><strong>{{ campaign.name }}</strong><div class="item-sub">ID {{ campaign.id }}</div></td>
          <td>{{ formatStatus(campaign.status) }}</td>
          <td>{{ campaign.metrics.cost | currency : 'BRL' : 'symbol' : '1.2-2' }}</td>
          <td>{{ campaign.metrics.impressions | number : '1.0-0' }}</td>
          <td>{{ campaign.metrics.clicks | number : '1.0-0' }}</td>
          <td>{{ campaign.metrics.conversions | number : '1.0-0' }}</td>
          <td>{{ campaign.metrics.sales | currency : 'BRL' : 'symbol' : '1.2-2' }}</td>
          <td><strong>{{ campaign.metrics.roas | number : '1.2-2' }}x</strong></td>
          <td>{{ campaign.metrics.ctr | number : '1.2-2' }}%</td>
        </tr>
        }
      </tbody>
    </table>
  </section>

  <section class="card table-wrap">
    <h2>Anúncios / produtos anunciados</h2>
    <p class="section-caption">Aqui a Luscilia consegue ver quais produtos estão gastando, convertendo ou precisando de ajuste.</p>
    <table>
      <caption class="visually-hidden">Anúncios e produtos com métricas de publicidade</caption>
      <thead><tr><th scope="col">Anúncio</th><th scope="col">Situação</th><th scope="col">Gasto</th><th scope="col">Cliques</th><th scope="col">Conversões</th><th scope="col">Vendas</th><th scope="col">ROAS</th><th scope="col">CPC</th><th scope="col">Conversão</th></tr></thead>
      <tbody>
        @for (ad of topAds(); track ad.id) {
        <tr>
          <td><strong>{{ ad.title || ad.name }}</strong><div class="item-sub">Item {{ ad.itemId || ad.id }}</div></td>
          <td><span class="status-chip" [ngClass]="healthClass(ad)">{{ healthLabel(ad) }}</span></td>
          <td>{{ ad.metrics.cost | currency : 'BRL' : 'symbol' : '1.2-2' }}</td>
          <td>{{ ad.metrics.clicks | number : '1.0-0' }}</td>
          <td>{{ ad.metrics.conversions | number : '1.0-0' }}</td>
          <td>{{ ad.metrics.sales | currency : 'BRL' : 'symbol' : '1.2-2' }}</td>
          <td><strong>{{ ad.metrics.roas | number : '1.2-2' }}x</strong></td>
          <td>{{ ad.metrics.cpc | currency : 'BRL' : 'symbol' : '1.2-2' }}</td>
          <td>{{ ad.metrics.conversionRate | number : '1.2-2' }}%</td>
        </tr>
        }
      </tbody>
    </table>
  </section>

  @if (weakAds().length > 0) {
  <section class="card table-wrap attention-table">
    <h2>Anúncios que merecem atenção</h2>
    <p class="section-caption">Gastaram no período, mas venderam pouco ou nada. Essa é a lista para ajustar título, preço, foto, descrição ou pausar.</p>
    <table>
      <caption class="visually-hidden">Anúncios de publicidade que merecem atenção</caption>
      <thead><tr><th scope="col">Anúncio</th><th scope="col">Motivo</th><th scope="col">Gasto</th><th scope="col">Cliques</th><th scope="col">Vendas</th><th scope="col">ROAS</th></tr></thead>
      <tbody>
        @for (ad of weakAds(); track ad.id) {
        <tr>
          <td><strong>{{ ad.title || ad.name }}</strong><div class="item-sub">Item {{ ad.itemId || ad.id }}</div></td>
          <td><span class="status-chip" [ngClass]="healthClass(ad)">{{ healthLabel(ad) }}</span></td>
          <td>{{ ad.metrics.cost | currency : 'BRL' : 'symbol' : '1.2-2' }}</td>
          <td>{{ ad.metrics.clicks | number : '1.0-0' }}</td>
          <td>{{ ad.metrics.sales | currency : 'BRL' : 'symbol' : '1.2-2' }}</td>
          <td>{{ ad.metrics.roas | number : '1.2-2' }}x</td>
        </tr>
        }
      </tbody>
    </table>
  </section>
  }

  @if (ads.errors.length > 0) {
  <section class="card table-wrap technical-notes">
    <h2>Observações técnicas da API</h2>
    <p class="section-caption">Se aparecerem erros aqui, pode ser permissão de Mercado Ads, endpoint indisponível ou janela que a API não aceitou.</p>
    @for (error of ads.errors; track error) {
      <p class="error-line">{{ error }}</p>
    }
  </section>
  }
  }
</main>
